module.exports = __webpack_public_path__ + "static/platnosci-zblizeniowe-73f8866c4292be354e028a7f5526ac08.jpg";